import script from "./testPlateChange.vue?vue&type=script&setup=true&lang=js"
export * from "./testPlateChange.vue?vue&type=script&setup=true&lang=js"

import "./testPlateChange.vue?vue&type=style&index=0&id=c540b290&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c540b290"]])

export default __exports__